import { Link } from 'react-router-dom';
import useScrollReveal from '../hooks/useScrollReveal';
import './Pages.css';
import './Home.css';

const POSTER = '/images/work/Silver-Joy-Still-1.webp';
const REEL_VIDEO = '/media/ZaireColor-Reel-2025-compressed.mp4';

const featured = [
    '/images/work/Cloudmaker-Still-2.webp',
    '/images/work/6LACK-On-Me-Still-2.webp',
    '/images/work/Red-Bull-Still-4.webp',
    '/images/work/Secret-Game-Still-4.webp',
];

function Home() {
    const introRef = useScrollReveal();
    const gridRef = useScrollReveal();

    return (
        <>
            <section className="home-hero">
                <video
                    className="home-hero-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={POSTER}
                >
                    <source src={REEL_VIDEO} type="video/mp4" />
                </video>
                <div className="home-hero-scrim" />
                <div className="home-hero-overlay">
                    <h1 className="home-hero-title">ZaireColor</h1>
                    {/* <p className="home-hero-subtitle">Colorist</p> */}
                    <Link to="/info" className="home-hero-cta">
                        Contact
                    </Link>
                </div>
                <div className="home-scroll-hint" aria-hidden="true">&#8595;</div>
            </section>

            <div className="page">


                <div className="home-featured reveal" ref={gridRef}>
                    {featured.map((src, i) => (
                        <Link
                            to="/work"
                            key={src}
                            className={`home-featured-item ${i === 0 ? 'home-featured-lead' : ''}`}
                        >
                            <img src={src} alt="" loading="lazy" />
                        </Link>
                    ))}
                </div>

                <div className="home-links">
                    <Link to="/work" className="home-link-btn">Selected Work</Link>
                    <Link to="/info" className="home-link-btn">About</Link>
                </div>
            </div>
        </>
    );
}

export default Home;
